import { useConfig, useUserContext } from "app/contexts";

/**
 * Whether this deployment opts in to SSO users creating and managing their
 * own API keys (the sso_api_keys terraform variable, surfaced as a top-level
 * boolean in the application config).
 */
export function useSsoApiKeysEnabled() {
  const config = useConfig();

  return Boolean(config?.sso_api_keys);
}

export function usePersonalApiKeysEnabled() {
  const { currentUser } = useUserContext();
  const ssoApiKeysEnabled = useSsoApiKeysEnabled();

  // Personal API Keys are only available for non SSO users, unless the
  // deployment opts in to SSO users managing their own keys
  return !currentUser.ssoUser || ssoApiKeysEnabled;
}
